<template>
	<div class="layout">
		<Layout id="index-1">
			<Affix :offset-top="0">
				<Header style="background-color: #ffffff;height: 61px;border: 1px solid #d7dde4;">
					<Menu ref="menus" mode="horizontal" theme="light" :active-name="acvtion">
						<div class="layout-logo">
							<img src="../assets/logo.png" style="width: 100px;height: 30px;border-radius: 4px;" alt="">
						</div>

						<div class="layout-nav">
							<MenuItem name="0" style="height: 60px;text-align: center;" to="/">首页</MenuItem>
							<MenuItem name="ss_104" style="height: 60px;text-align: center;" to="/us">关于汇金</MenuItem>
							<MenuItem v-for="(item,index) in titleList" :name="'ss_'+item.id" :to="'/news?id='+item.id" v-if="item.id<100">
							{{item.name}}</MenuItem>
							<MenuItem name="99" style="height: 60px;text-align: center;" to="/map">联系我们</MenuItem>
						</div>
					</Menu>
				</Header>
			</Affix>
			<Content>

				<div style="background-color: #FFFFFF;">
					<Row :gutter="16" type="flex" justify="center">
						<Col span="20">
						<img style="width: 100%;" src="../assets/4.jpg" />
						</Col>
					</Row>
					<Row :gutter="16" type="flex" justify="center" style="margin-top: 20px;">
						<Col span="20" style="">
						<div class="">
							<div>
								<Row :gutter="16" type="flex" justify="center">
									<Col span="10">
									<div class="ytitle">
										<div class="item" :class="showIndex==0?'cheak':''" @click="showIndex=0">公司简介</div>
										<div class="item" :class="showIndex==1?'cheak':''" @click="showIndex=1">发展历程</div>
										<div class="item" :class="showIndex==2?'cheak':''" @click="showIndex=2">荣誉历史</div>
										<div class="item" :class="showIndex==3?'cheak':''" @click="showIndex=3">社会责任</div>
										<div class="item" :class="showIndex==4?'cheak':''" @click="showIndex=4">党建工作</div>
									</div>

									</Col>
								</Row>
							</div>
							<div v-if="showIndex==0">
								<div style="width: 68%;float: left;padding: 10px;font-size: 20px;line-height: 33px;">
									<p>
										汇金永信保险销售服务有限公司成立于2011年10月8日，是一家全国性的专业化保险销售服务公司。公司经营范围：在全国区域内（港、澳、台除外）代理销售保险产品；代理收取保险费；代理相关保险业务的损失勘查和理赔；中国保监会批准的其他业务。<br>
										截止到2023年2月，公司拥有内外勤员工5000人；已在四川、重庆、江苏、北京、上海、天津、河北、山东、青岛、河南、湖南等省、市开设分支机构68家，多家省市级分公司正在筹建中。<br>
										上级股东单位四川正和祥健康药房连锁，集团旗下拥有9家零售连锁公司、1家加盟连锁公司、1家批发公司、1家诊所连锁公司、1家中药生产企业和1家保险销售公司。股东旗下有5000余家医药门店覆盖四川、贵州、湖南、重庆等地。公司目前分别与正和祥、楚济堂、睿保医云建立了深度的战略合作机制。<br>
										公司的经营理念：阳光创业、永续经营；公司的核心价值观：诚信、创新、专业、服务；公司愿景：让保险助力亿万家庭幸福生活！公司使命：为伙伴搭建永续的经营平台，为大众提供专业的保险服务。<br>
										公司根据目前市场现状，并结合自身特点，提出“以寿险综合开拓为主，以非寿险为辅”的指导思想。公司重点关注业务品质，个人寿险13J继续率持续保持在96%以上。<br>
										公司具有全国互联网销售资质：公司运营的移动互联网平台“畅快保”，实现B端、C端分层级运用；着眼于大数据分析，为客户提供一站式优质保险服务，为员工提供先进的展业工具，现已初见成效。<br>
										公司自主研发的核心业务系统实现了寿险、团财险、互联网业务管理标准化、系统化，集成了业务管理、人员管理、财务管理等核心模块于一体，符合国家及银保监对保险专业中介对信息化安全的要求。获得国家公安部颁发的《信息系统安全等级保护三级备案证明》。2021年12月已顺利通过监管部门验收，成为《四川省保险专业中介机构信息化白名单》首批成员。<br>
										未来展望：公司预计在未来五年的发展期内，实现寿险保费业务产值累计10亿元，非寿险保费产值累计50亿元；建设省级分支机构20家，地市级分支机构60家，未来五年完成在全国二线城市以上重点区域布局，公司着力打造西南地区第一保险销售服务品牌。
								
									</p>
								</div>
								<div style="width: 30%;float: right; padding: 10px;">
									<img src="../assets/bg33.jpg" style="width: 100%;" />
								</div>
							</div>
							<div v-if="showIndex==1">
								<div style="margin: 0 auto;width: 400px;margin-top: 20px;">
									<Timeline>
										<TimelineItem>
											<p class="time">2023.01.17 </p>
											<p class="content">四川分公司乔迁新址；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2022.11.04 </p>
											<p class="content">汇金营销期刊创刊发布；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2022.07 </p>
											<p class="content"> 汇金永信2022年寿险新单承保保费突破1亿元；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2022.07.22 </p>
											<p class="content">董事长当选四川省保险中介行业协会会长；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2022.05.17 </p>
											<p class="content"> 四川银保监局莅临汇金永信调研；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2021.09.02 </p>
											<p class="content"> 湖南分公司开业；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2021.08.04 </p>
											<p class="content"> 畅快保APP公测上线运营；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2021.01.01 </p>
											<p class="content">四川分公司开业；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2019.09.17 </p>
											<p class="content"> 河南分公司开业；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2019.09.05 </p>
											<p class="content"> 畅快保公众号升级运营；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018.09.28 </p>
											<p class="content"> 青岛分公司开业；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018.08.10 </p>
											<p class="content"> 天津分公司开业；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018.06 </p>
											<p class="content"> 上海、北京、河北、山东分公司先后开业；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2017.12.14 </p>
											<p class="content">畅快保公众号开通运营；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2017.11.16 </p>
											<p class="content"> 江苏分公司成立；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2017.04.25 </p>
											<p class="content"> 重庆分公司成立；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2013.04.21 </p>
											<p class="content"> 公司组织参加“4.20芦山地震”抗震救灾活动；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2013.01.24 </p>
											<p class="content"> 公司更名为汇金永信保险销售服务有限公司并变更经营范围为全国；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2011.08.31 </p>
											<p class="content">公司注册资本增资至5000万元；</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2011.10.08 </p>
											<p class="content">四川汇金永信保险代理有限公司批准成立；</p>
										</TimelineItem>
									</Timeline>
								</div>
								
							</div>
							<div v-if="showIndex==2">
								<div style="margin: 0 auto;width: 400px;margin-top: 20px;">
									<Timeline>
										<TimelineItem>
											<p class="time">2022 </p>
											<p class="content">当选四川保险中介行业协会“会长单位”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2022 </p>
											<p class="content">获得华泰财险“最佳合作伙伴”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2022 </p>
											<p class="content">获得四川银行业保险业2022年清廉文化知识竞赛“优秀组织奖”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2021 </p>
											<p class="content">获得恒大人寿“经英推广大使”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2021 </p>
											<p class="content">获得工银安盛人寿“优秀合作单位”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2019 </p>
											<p class="content">获得陆家嘴国泰人寿“优秀合作单位”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2019 </p>
											<p class="content">获得恒大人寿“优秀合作机构奖”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2019 </p>
											<p class="content">获得天安人寿“续期品质优秀奖”</p>
										</TimelineItem>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2019 </p>
											<p class="content">获得恒安标准人寿“精诚合作奖”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2019 </p>
											<p class="content">获得陆家嘴国泰人寿“优秀合作渠道”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018 </p>
											<p class="content">获得众安在线“优秀合作伙伴奖”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018 </p>
											<p class="content">获得中意人寿“年度优秀合作商”</p>
										</TimelineItem>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018 </p>
											<p class="content">当选四川省保险中介行业协会“副会长单位”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018 </p>
											<p class="content">获得陆家嘴国泰人寿“卓越合作渠道”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018 </p>
											<p class="content">获得恒大人寿“最佳品质合作机构奖”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018 </p>
											<p class="content">获得中意人寿“年度优秀合作商”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2018 </p>
											<p class="content">获得泰康人寿“卓越合作渠道”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2017 </p>
											<p class="content">获得中英人寿“中英经代最佳合作伙伴”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2017 </p>
											<p class="content">获得恒大人寿“杰出合作机构奖”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2016 </p>
											<p class="content">年荣获同方全球人寿“最佳贡献合作商”</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2013 </p>
											<p class="content">年荣获中意人寿经销宝“出单最多的合作公司”</p>
										</TimelineItem>
									</Timeline>
								</div>
							</div>
							<div v-if="showIndex==3">
								<div style="width: 100%;text-align: center;font-size: 18px;margin-bottom: 20px;">
									<p>
										我们认为，作为一个有良心和有远见的企业，我们不仅要为股东创造价值，也要为员工、客户、合作伙伴和社会创造价值。<br>
										我们秉持“正直向善、科技创新、创造价值、担当责任、合作共赢”的社会责任理念。我们相信，只有承担相应的社会责任，才能实现各个方面的共赢。
									</p>
								</div>
								<div style="margin: 0 auto;width: 400px;margin-top: 40px;">
									<Timeline>
										<TimelineItem>
											<p class="time">2022年12月 </p>
											<p class="content">汇金永信为员工采购抗疫药品</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2022年9月 </p>
											<p class="content">汇金永信员工参与社区抗疫</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2022年2月 </p>
											<p class="content">汇金永信上分员工参与社区抗疫</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2021年7月8日 </p>
											<p class="content">汇金永信参与“7.8保险公众宣传日</p>
										</TimelineItem>
										<TimelineItem>
											<p class="time">2020年 </p>
											<p class="content">汇金永信四川分公司去往养老院慰问</p>
										</TimelineItem>
									</Timeline>
								</div>
							</div>
							<div v-if="showIndex==4">
								<div class="newBody" v-for="(item,index) in data1" @click="openWindows(item.id)" >
									<div class="timer">
										<strong>{{getDD(item.createTime)}}</strong>
										<span>{{getYYYYMM(item.createTime)}}</span>
									</div>
									<div class="body">
										<div class="title">{{item.title}}</div>
										<div class="body" v-html="delHtmlTag(item.body)"></div>
									</div>
								</div>
								<div v-if="data1.length==0" style="text-align: center;color: #d7dde4; padding: 100px;">暂无新闻</div>
								<Page :total="total" show-total style="margin-top: 20px;margin-bottom: 20px;"
									@on-change="goNextPage" />
							</div>
							
						</div>

						</Col>

					</Row>
				</div>


			</Content>
			<Footer id="index-1" class="layout-footer-center">2022 &copy; 汇金永信保险销售服务有限公司
				<div>
					  联系方式：028-85224343
					  邮件：hjyxcoltd@163.com<br>
					网站版权所有 hjyxbx.com 所有
					Copyright © 2013 蜀ICP备13002380号   四川省成都市高新区府城大道中段88号中航城市广场1205室
				</div>
			</Footer>
		</Layout>
		<Drawer title="新闻详情" :width="1024" :closable="false" v-model="openNews">
			<h5>{{showbody.title}}</h5>
			<Divider />
			<p v-html="showbody.body">
			</p>
		</Drawer>
		<BackTop></BackTop>
	</div>
</template>
<script>
	import {
		sendMsg
	} from '../api/index.js'
	import moment from 'moment'
	import striphtml from 'js-striphtml'
	export default {
		data() {
			return {
				showIndex: 0,
				acvtion: "ss_104",
				columns1: [{
						title: '标题',
						key: 'title'
					},
					{
						width: 200,
						title: '创建时间',
						key: 'createTime',
						render: (h, dto) => {
							return h('div', [h('span', moment(dto.row.createTime).format('YYYY-MM-DD hh:mm:ss'))])
						},
						sortType: "desc",
						align: "right"
					}
				],
				data1: [],
				openNews: false,
				showbody: {},
				titleList: [],
				total: 0,
				page: 1,
				typeID: 105,
				pageWhere: "关于汇金"
			}
		},
		watch: {
			$route: { // 亲测有效,我是用来监听query参数变化
				handler() {
					this.typeID = this.$route.query.id;
					this.initData()

				},
				deep: true,
			}
		},
		created() {
			this.initData()
			
		},
		mounted() {

		},
		updated() {
			
		},


		methods: {
			delHtmlTag(str) {
				return str.replace(/<[^>]+>/g, '')
			},
			getDD(e) {
				return moment(e).format('DD')
			},
			getYYYYMM(e) {
				return moment(e).format('YYYY-MM')
			},

			showTable(e) {
				this.openNews = true
				this.showbody = e
			},
			goNextPage(e) {
				this.page = e;
				console.info(this.page)
				this.initData()
			},
			menuChange() {
				this.acvtion = 'ss_' + this.typeID
				this.$nextTick(() => {
					this.$refs.menus.updateOpened()
					this.$refs.menus.updateActiveName();
				})
			},
			initData() {
				let that = this
				sendMsg("/baseNews/list", {
					limit: 10,
					page: this.page,
					type: this.typeID
				}, 'POST', false).then(res => {
					this.data1 = res.data.data
					this.total = res.data.count
				})
				sendMsg("/baseType/list", {}, "POST", false).then(res => {
					this.titleList = res.data.data
					for(var i = 0;i<res.data.data.length;i++){
						console.info(res.data.data[i].id)
						if(res.data.data[i].id == that.typeID){
							console.info(res.data.data[i].name)
							that.pageWhere = res.data.data[i].name
						}
						
					}
				})
			},
		},
		components: {
			sendMsg
		}
	}
</script>


<style scoped>
	.layout {
		border: 1px solid #d7dde4;
		background: #f5f7f9;
		position: relative;
		border-radius: 4px;
		overflow: hidden;
	}

	.layout-logo {
		width: 100px;
		height: 30px;
		border-radius: 3px;
		float: left;
		position: relative;
		top: 15px;
		left: 20px;
	}

	.layout-nav {
		float: right;
		min-width: 420px;
		margin: 0 auto;
		margin-right: 20px;
	}

	.layout-footer-center {
		text-align: center;
	}

	.demo-carousel {
		background-color: #D7DDE4;

	}

	.section-title {
		text-align: center;
		position: relative;
		padding: 0 0 15px;
		margin-bottom: 15px;
		font-weight: 600;
	}

	.section-title::before {
		bottom: 0;
		width: 60px;
	}

	.section-title::after,
	.section-title::before {
		position: absolute;
		content: "";
		left: 50%;
		height: 2px;
		background: #0033CC;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
	}

	.section-title span {
		margin-right: 10px;
		margin-left: 10px;
		color: #0033CC;
	}

	.section-title::after {
		bottom: -5px;
		width: 30px;
	}

	.section-title::after,
	.section-title::before {
		position: absolute;
		content: "";
		left: 50%;
		height: 2px;
		background: #0033CC;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
	}

	*,
	::after,
	::before {
		box-sizing: border-box;
	}

	h2 {
		font-size: 2.25rem;
	}

	.nbox {
		padding: 30px 30px 10px 30px;
		min-height: 260px;
		box-shadow: 0 10px 20px 0 rgba(0, 51, 204, 0.1);
	}

	.nbox .box {
		line-height: 80px;
		border-radius: 10px;
		width: 80px;
		background: #0033CC;
		color: #fff;
		font-size: 1.25rem;
		text-align: center;
		font-weight: 600;
		-webkit-box-shadow: 0 10px 16px 0 rgba(0, 51, 204, 0.15);
		box-shadow: 0 10px 16px 0 rgba(0, 51, 204, 0.15);
		margin-bottom: 20px;

	}

	h5 {
		font-size: 1.375rem;
	}

	.layui-table {
		border-collapse: collapse;
		border-spacing: 0;
		empty-cells: show;
		border: 1px solid #cbcbcb;
	}

	.layui-table caption {
		color: #000;
		font: italic 85%/1 arial, sans-serif;
		padding: 1em 0;
		text-align: center;
	}

	.layui-table td,
	layui-table th {
		border-left: 1px solid #cbcbcb;
		border-width: 0 0 0 1px;
		font-size: inherit;
		margin: 0;
		overflow: visible;
		padding: .5em 1em;
	}

	.layui-table thead {
		background-color: #e0e0e0;
		color: #000;
		text-align: left;
		vertical-align: bottom;
	}

	.layui-table td {
		background-color: transparent;
	}

	.newBody {
		display: flex;
		justify-content: space-around;
		align-items: center;
		border: 1px solid #d6d6d6d6;
		height: 100px;
		box-shadow: 3px 3px 1px 1px #f6f7f9;
		margin-bottom: 20px;
		cursor: pointer;
	}

	.newBody .timer {
		width: 70px;
		float: left;
	}

	.newBody .timer strong {
		display: block;
		line-height: 50px;
		background-color: #2d8cf0;
		text-align: center;
		font-size: 28px;
		color: #fff;
	}

	.newBody .timer span {
		display: block;
		line-height: 22px;
		text-align: center;
		font-size: 12px;
		color: #fff;
		margin-top: 1px;
		background-color: #ccc;
	}

	.newBody .body {
		width: 92%;
	}

	.newBody .body .title {
		font-weight: 700;
		font-size: 16px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		-ms-text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
	}

	.newBody .body .body {
		font-size: 14px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		-ms-text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
		white-space: nowrap;
		/*文本不换行*/
	}

	.time {
		font-size: 20px;
		font-weight: bold;
	}

	.content {
		font-size: 16px;
		padding-left: 10px;
	}

	p {
		text-indent: 2em;
	}

	.outer-class .ivu-tabs-nav-wrap {
		text-align: center;
	}

	.outer-class .ivu-tabs-nav-scroll {
		display: inline-block;
	}

	.ytitle {
		width: 100%;
		text-align: center;
		height: 60px;
		margin-bottom: 20px;
	}

	.ytitle .item {
		width: 20%;
		float: left;
		height: 60px;
		font-size: 26px;
		line-height: 60px;
		cursor: pointer;
	}

	.cheak {
		color: #2d8cf0;

	}

	.cheak::before {
		content: "";
		display: inline-block;
		width: 104px;
		height: 4px;
		position: absolute;
		bottom: 24px;
		background-color: #FF6600;
		margin-right: 6px;
	}
	.newBody{
		display: flex;
		justify-content: space-around;
		align-items: center;
		border: 1px solid #d6d6d6d6;
		height: 100px;
		box-shadow: 3px 3px 1px 1px #f6f7f9;
		margin-bottom: 20px;
		cursor:pointer;
	}
	.newBody .timer{
		width: 70px;
		float: left;
	}
	.newBody .timer strong{
		display: block;
		line-height: 50px;
		background-color: #2d8cf0;
		text-align: center;
		font-size: 28px;
		color: #fff;
	}
	.newBody .timer span{
		display: block;
		line-height: 22px;
		text-align: center;
		font-size: 12px;
		color: #fff;
		margin-top: 1px;
		background-color: #ccc;
	}
	.newBody .body{
		width: 92%;
	}
	.newBody .body .title{
		font-weight: 700;
		font-size: 16px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		-ms-text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
	}
	.newBody .body .body{
		font-size: 14px;
		height: 35px;
		line-height: 35px;
		overflow: hidden;
		text-align: left;
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		-ms-text-overflow: ellipsis;
		-o-text-overflow: ellipsis;
		    white-space: nowrap;     /*文本不换行*/
	}
</style>
